import { render, staticRenderFns } from "./FormStory.vue?vue&type=template&id=b40ca802"
import script from "./FormStory.vue?vue&type=script&lang=js"
export * from "./FormStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b40ca802')) {
      api.createRecord('b40ca802', component.options)
    } else {
      api.reload('b40ca802', component.options)
    }
    module.hot.accept("./FormStory.vue?vue&type=template&id=b40ca802", function () {
      api.rerender('b40ca802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FormStory/FormStory.vue"
export default component.exports